import * as React from "react";
import styled from "styled-components";

import { HeaderItemCss } from "./styled";

interface IProps {
  children?: React.ReactNode | undefined;
  className?: string;
  toggleChild: React.ReactNode;
  showToggleChild: boolean;
  onToggle: () => void;
  id?: string;
}

export const HeaderToggleItem: React.FC<IProps> = ({
  onToggle,
  showToggleChild,
  toggleChild,
  children,
  className,
  id,
}) => {
  return (
    <HeaderToggleItemContainer className={className}>
      <HeaderToggleButton onClick={onToggle} data-test-id={id}>
        {children}
      </HeaderToggleButton>
      {showToggleChild ? toggleChild : null}
    </HeaderToggleItemContainer>
  );
};

const HeaderToggleItemContainer = styled.div`
  position: relative;
`;

const HeaderToggleButton = styled.button`
  ${HeaderItemCss}
`;
